import type { AppointmentCtaData } from '@/data/types';

interface AppointmentCtaProps {
  data: AppointmentCtaData;
}

export function AppointmentCta({ data }: AppointmentCtaProps) {
  return (
    <section className="bg-red-500 text-white py-16">
      <div className="container mx-auto px-4 text-center">
        <h3 className="text-2xl md:text-3xl font-bold mb-4">
          {data.title}
        </h3>
        <p className="text-xl mb-8 text-red-100">
          {data.description}
        </p>
        <a
          href={data.ctaLink}
          className="inline-block bg-white text-red-500 px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors text-lg"
        >
          {data.ctaText}
        </a>
      </div>
    </section>
  );
}